import { render, staticRenderFns } from "./DatatableMaterialNDispensado.vue?vue&type=template&id=00bb654b&scoped=true"
import script from "./DatatableMaterialNDispensado.vue?vue&type=script&lang=js"
export * from "./DatatableMaterialNDispensado.vue?vue&type=script&lang=js"
import style0 from "./DatatableMaterialNDispensado.vue?vue&type=style&index=0&id=00bb654b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00bb654b",
  null
  
)

export default component.exports